import { IconProps } from ".";

export type IoIconProps = IconProps & {
  /** When true, use currentColor (no gradient). Use for light theme. */
  inheritColor?: boolean;
};

export const IoIcon: React.FC<IoIconProps> = ({ inheritColor, ...props }) => {
  const pathFill = (id: string) => (inheritColor ? "currentColor" : `url(#${id})`);

  // return (
  //   <svg viewBox="0 0 28 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
  //     <path
  //       d="M19.9273 2.97475e-05H2.91928L7.1669 2.82797H19.9273C20.4226 2.82797 20.8303 3.22053 20.8303 3.70276V5.81341L23.7496 7.75686V3.70276C23.7496 1.66723 22.0311 2.97475e-05 19.9273 2.97475e-05Z"
  //       fill={pathFill("paint0_linear_14702_15586")}
  //     />
  //     <path
  //       d="M10.992 12H28L23.7524 9.17207H10.992C10.4967 9.17207 10.089 8.77708 10.089 8.29727V6.18662L7.16966 4.24317V8.29727C7.16966 10.3377 8.88572 12 10.992 12Z"
  //       fill={pathFill("paint1_linear_14702_15586")}
  //     />
  //     <path d="M2.9193 4.24314H0V12H2.9193V4.24314Z" fill={pathFill("paint2_linear_14702_15586")} />
  //     <path
  //       d="M0 0V2.42325L2.81674 4.29885L2.9193 4.24314L2.91928 2.97475e-05L0 0Z"
  //       fill={pathFill("paint3_linear_14702_15586")}
  //     />
  //     {!inheritColor && (
  //     <defs>
  //       <linearGradient
  //         id="paint0_linear_14702_15586"
  //         x1="-2.03039"
  //         y1="2.14887"
  //         x2="19.6908"
  //         y2="2.14887"
  //         gradientUnits="userSpaceOnUse"
  //       >
  //         <stop stopColor="#A7A9AC" />
  //         <stop offset="0.0091653" stopColor="#AAACAF" />
  //         <stop offset="0.1095" stopColor="#C9CACC" />
  //         <stop offset="0.203" stopColor="#DFE0E1" />
  //         <stop offset="0.2859" stopColor="#ECEDEE" />
  //         <stop offset="0.35" stopColor="#F1F2F2" />
  //         <stop offset="0.4681" stopColor="#EAEBEC" />
  //         <stop offset="0.6561" stopColor="#D7D8DA" />
  //         <stop offset="0.8892" stopColor="#B8BABC" />
  //         <stop offset="1" stopColor="#A7A9AC" />
  //       </linearGradient>
  //       <linearGradient
  //         id="paint1_linear_14702_15586"
  //         x1="-2.03039"
  //         y1="2.14887"
  //         x2="19.6908"
  //         y2="2.14887"
  //         gradientUnits="userSpaceOnUse"
  //       >
  //         <stop stopColor="#A7A9AC" />
  //         <stop offset="0.0091653" stopColor="#AAACAF" />
  //         <stop offset="0.1095" stopColor="#C9CACC" />
  //         <stop offset="0.203" stopColor="#DFE0E1" />
  //         <stop offset="0.2859" stopColor="#ECEDEE" />
  //         <stop offset="0.35" stopColor="#F1F2F2" />
  //         <stop offset="0.4681" stopColor="#EAEBEC" />
  //         <stop offset="0.6561" stopColor="#D7D8DA" />
  //         <stop offset="0.8892" stopColor="#B8BABC" />
  //         <stop offset="1" stopColor="#A7A9AC" />
  //       </linearGradient>
  //       <linearGradient
  //         id="paint2_linear_14702_15586"
  //         x1="-2.03039"
  //         y1="2.14887"
  //         x2="19.6908"
  //         y2="2.14887"
  //         gradientUnits="userSpaceOnUse"
  //       >
  //         <stop stopColor="#A7A9AC" />
  //         <stop offset="0.0091653" stopColor="#AAACAF" />
  //         <stop offset="0.1095" stopColor="#C9CACC" />
  //         <stop offset="0.203" stopColor="#DFE0E1" />
  //         <stop offset="0.2859" stopColor="#ECEDEE" />
  //         <stop offset="0.35" stopColor="#F1F2F2" />
  //         <stop offset="0.4681" stopColor="#EAEBEC" />
  //         <stop offset="0.6561" stopColor="#D7D8DA" />
  //         <stop offset="0.8892" stopColor="#B8BABC" />
  //         <stop offset="1" stopColor="#A7A9AC" />
  //       </linearGradient>
  //       <linearGradient
  //         id="paint3_linear_14702_15586"
  //         x1="-2.03039"
  //         y1="2.14887"
  //         x2="19.6908"
  //         y2="2.14887"
  //         gradientUnits="userSpaceOnUse"
  //       >
  //         <stop stopColor="#A7A9AC" />
  //         <stop offset="0.0091653" stopColor="#AAACAF" />
  //         <stop offset="0.1095" stopColor="#C9CACC" />
  //         <stop offset="0.203" stopColor="#DFE0E1" />
  //         <stop offset="0.2859" stopColor="#ECEDEE" />
  //         <stop offset="0.35" stopColor="#F1F2F2" />
  //         <stop offset="0.4681" stopColor="#EAEBEC" />
  //         <stop offset="0.6561" stopColor="#D7D8DA" />
  //         <stop offset="0.8892" stopColor="#B8BABC" />
  //         <stop offset="1" stopColor="#A7A9AC" />
  //       </linearGradient>
  //     </defs>
  //     )}
  //   </svg>
  // );

  return (
    <svg viewBox="0 0 23 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M20.6429 0.289999C20.4477 0.0999994 20.1908 0 19.9134 0H7.10028C6.82284 0 6.56596 0.109999 6.37073 0.289999L4.92193 1.7C4.7267 1.89 4.62394 2.14 4.62394 2.41V3H19.3174V7.5H22.4V2.41C22.4 2.14 22.287 1.89 22.102 1.7L20.6532 0.289999H20.6429Z"
        fill="currentColor"
      />
      <path
        d="M7.70642 9V4.5H4.62385V9.59C4.62385 9.86 4.73688 10.11 4.92184 10.3L6.37064 11.71C6.56587 11.9 6.82275 12 7.10018 12H19.9237C20.2011 12 20.458 11.89 20.6532 11.71L22.102 10.3C22.2972 10.11 22.4 9.86 22.4 9.59V9H7.70642Z"
        fill={"currentColor"}
      />
      <path
        d="M0 9.59C0 9.86 0.113028 10.11 0.297982 10.3L1.74679 11.71C1.94202 11.9 2.1989 12 2.47633 12H3.08257V4.5H0V9.59Z"
        fill={"currentColor"}
      />
      <path
        d="M1.74679 0.289999L0.297982 1.7C0.102752 1.89 0 2.14 0 2.41V3H3.08257V0H2.47633C2.1989 0 1.94202 0.109999 1.74679 0.289999Z"
        fill={"currentColor"}
      />
    </svg>
  );
};
